<app-project-tree [selectedNode]="data.selectedNode" (selectedNodeChange)="selectedNodeChangeProxy($event)"></app-project-tree>
